import { takeEvery, all, call, put } from 'redux-saga/effects'

import * as actions from './actions'
import * as URL from './url'
import { api } from '../api'

function* fetchOrders(action) {
    try {
        yield put(actions.OrdersLoadingStart())
        const { pageNo, size, search } = action.payload
        const { data } = yield call(api, URL.getOrdersListURL(pageNo, size, search), 'GET')
        yield put(
            actions.fetchOrdersSuccess({
                orders_list: data.data,
                count: data.total_items,
                pageNo: action.payload.pageNo,
                size: action.payload.size,
                order: action.payload.sort[Object.keys(action.payload.sort)[0]],
                orderBy: Object.keys(action.payload.sort)[0],
            })
        )
    } catch (e) {
        console.log('fetch orders error', e)
        if (e?.message) {
            yield put(actions.setOrderError(e.message))
        }
    } finally {
        yield put(actions.OrdersLoadingEnd())
    }
}

export default function* watchOrders() {
    yield all([takeEvery(actions.actionTypes.SAGA_FETCH_ORDERS, fetchOrders)])
}
